import { render } from "./inspectionList.vue?vue&type=template&id=ea48244e"
import script from "./inspectionList.vue?vue&type=script&lang=js"
export * from "./inspectionList.vue?vue&type=script&lang=js"

import "./inspectionList.vue?vue&type=style&index=0&id=ea48244e&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__